// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore/lite';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
  apiKey: "AIzaSyAGrpcZ11BoiDYdUWlETJyz4k6ZhYN33Xg",
  authDomain: "myprofile-e12cf.firebaseapp.com",
  projectId: "myprofile-e12cf",
  storageBucket: "myprofile-e12cf.appspot.com",
  messagingSenderId: "840921533866",
  appId: "1:840921533866:web:93ed4e0a6aec0894496fd3",
  measurementId: "G-8S5T8JT9K5"
};
  
  // Initialize Firebase
  const app = initializeApp(firebaseConfig);

  const db = getFirestore(app);

  export default db;